import React from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const styles = {
  passwordContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  textfield: {
    marginBottom: '12px',
    width: '320px',
  },
};

const PasswordFieldsCollapse = ({
  open,
  disabled,
  passwordValue,
  confirmPasswordValue,
  passwordError,
  confirmPasswordError,
  required,
  showPassword1,
  showPassword2,
  onToggleShowPassword1,
  onToggleShowPassword2,
  onChange,
}) => {
  return (
    <Collapse in={open} timeout={250} unmountOnExit>
      <div style={styles.passwordContainer}>
        <TextField
          id="password"
          label="Password"
          required={required}
          value={passwordValue}
          name="password"
          onChange={onChange}
          disabled={disabled}
          style={styles.textfield}
          helperText={passwordError}
          error={!!passwordError}
          type={showPassword1 ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip
                  title={
                    showPassword1 ? 'Nascondi password' : 'Mostra password'
                  }
                >
                  <IconButton
                    aria-label={
                      showPassword1 ? 'Nascondi password' : 'Mostra password'
                    }
                    onClick={onToggleShowPassword1}
                  >
                    {showPassword1 ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />

        <TextField
          id="confirmPassword"
          label="Ripeti password"
          required={required}
          value={confirmPasswordValue}
          name="confirmPassword"
          onChange={onChange}
          disabled={disabled}
          style={styles.textfield}
          helperText={confirmPasswordError}
          error={!!confirmPasswordError}
          type={showPassword2 ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip
                  title={
                    showPassword2 ? 'Nascondi password' : 'Mostra password'
                  }
                >
                  <IconButton
                    aria-label={
                      showPassword2 ? 'Nascondi password' : 'Mostra password'
                    }
                    onClick={onToggleShowPassword2}
                  >
                    {showPassword2 ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </div>
    </Collapse>
  );
};

PasswordFieldsCollapse.propTypes = {
  open: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  passwordValue: PropTypes.string.isRequired,
  confirmPasswordValue: PropTypes.string.isRequired,
  passwordError: PropTypes.string.isRequired,
  confirmPasswordError: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  showPassword1: PropTypes.bool.isRequired,
  showPassword2: PropTypes.bool.isRequired,
  onToggleShowPassword1: PropTypes.func.isRequired,
  onToggleShowPassword2: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PasswordFieldsCollapse;
